import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'ADMIN'

const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
if (userInfo && userInfo.userRole) initialRole = userInfo.role

export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    admin  : new AclRule('ADMIN').generate(),
    editor : new AclRule('SUPERADMIN').or('ADMIN').generate()
  }
})
